export default {
  methods: {
    goBack () {
      this.$router.push({
        name: 'Users'
      }).then()
    }
  }
}
